const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}/changelog/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { zodSearchValidator } from "@tanstack/router-zod-adapter";
import { httpClient } from "@/lib/http-client";
import { dehydrate } from "@tanstack/react-query";
import i18n from "@/lib/i18n";
interface DefaultHit {
  _id: string;
  timestamp: string;
  metadata: Metadata;
}
interface Metadata {
  changes: Change[];
  contextId: string;
  contextType: string;
}
interface Change {
  changeType: "insert" | "update" | "delete";
  field: string;
  newValue: unknown;
  oldValue: unknown;
}
interface OfferHit extends DefaultHit {
  metadata: Metadata & {
    contextType: "offer";
  };
  document: SingleOffer;
}
interface ItemHit extends DefaultHit {
  metadata: Metadata & {
    contextType: "item";
  };
  document: SingleItem;
}
interface AssetHit extends DefaultHit {
  metadata: Metadata & {
    contextType: "asset";
  };
  document: SingleItem;
}
interface Hit {
  _id: string;
  timestamp: string;
  metadata: Metadata;
  document: null;
}
const searchParamsSchema = z.object({
  query: z.preprocess(value => {
    if (typeof value === "string") return value;
    if (typeof value === "boolean") return "";
    return undefined;
  }, z.string()).optional(),
  page: z.number().optional()
});
export const Route = createFileRoute("/{-$locale}/changelog/")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  // @ts-expect-error - loader return type
  loader: async ({
    context,
    search
  }) => {
    const {
      queryClient
    } = context;
    const query = search?.query ?? "";
    const page = search?.page ?? 1;
    await queryClient.prefetchQuery({
      queryKey: ["changelogs", {
        query,
        page
      }],
      queryFn: () => httpClient.get<Root>("/search/changelog", {
        params: {
          query,
          page
        }
      }).catch(() => null)
    });
    return {
      dehydratedState: dehydrate(queryClient),
      page,
      query
    };
  },
  beforeLoad: async () => {},
  validateSearch: zodSearchValidator(searchParamsSchema),
  head() {
    return {
      meta: [{
        title: i18n.t("changelog.index.meta.title")
      }]
    };
  }
});